import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AppButton } from '@/components'
import { useAuthPreferencesStore } from '@/store'
import { useAuthScopedStore } from '@/store/scoped'

export const ContinueWithEmail: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const setIdentificationMethod = useAuthScopedStore(
    (state) => state.setIdentificationMethod,
  )
  const setAuthPreferences = useAuthPreferencesStore(
    (state) => state.setAuthPreferences,
  )

  const handlePress = () => {
    setIdentificationMethod('email')
    setAuthPreferences({
      signInMethod: 'email',
    })

    navigate('/auth/identifier/with-email')
  }

  return (
    <AppButton
      label={t('form:actions.continueWith', { authMethod: 'Email' })}
      onClick={handlePress}
      type="secondaryGrayDark"
      iconName="emailInline"
      iconSize={26}
      iconGap={12}
    />
  )
}
